module.exports = __webpack_public_path__ + "img/share-bg-15.7deb42fc.jpg";